<template>
	<div class="area">
		<div class="nodata_box">
			<img src="../../assets/img/nodata-img1.png" alt="">
			<div class="nodata_text">
				<div>{{message_t}}</div>
				<div>{{message_b}}</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "MessageSet",
		data() {
			return {
				message_t: '',
				message_b: '',
				message1: '您的体验期已到期',
				message2: '如果继续使用请联系客服进行开通~',
				message3: '您的账单支付已逾期，账号被暂时关闭',
				message4: '为避免账号关闭给您带来的不便请您尽快支付',
				message5: '您的账号当前为停用状态',
				message6: '如有问题请联系客服',
			};
		},
		created() {
			//this.loadData()
		},
		watch: {
		},
		methods:{
			loadData () {
				this.$axios.get('/find')
					.then(res => {
						if (res.data.t == 1) {
							this.message_t = this.message1
							this.message_b = this.message2
						} else if (res.data.t == 2) {
							this.message_t = this.message5
							this.message_b = this.message6
						} else {
							this.message_t = this.message3
							this.message_b = this.message4
						}
					})
			}
		}
	};
</script>
<style src="../../assets/css/common/nav.less" scoped lang="less"></style>
<style src="../../assets/css/common/card.less" scoped lang="less"></style>
<style src="../../assets/css/common/card.less" scoped lang="less"></style>
<style scoped lang="less">
	.area {
		margin: 42px auto;
		padding: 0 38px 0 48px;
		font-size: 14px;
		.nodata_box{
			font-size:24rpx;
			text-align:center;
		}
		.nodata_text{
			position: relative;
			top:-20px;
		}
		
	}
</style>